/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import LeftNav from "pages/Member/LeftNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import KYCForm from "../MobileKYC/KYCForm";

const DesktopKYC = observer(() => {
  const {
    authStore: { user },
  } = useStores();

  return (
    <main className="css-1wr4jig kyc-page">
      <main className="css-xry4yv !flex-row">
        <LeftNav />
        <div className="css-1wr4jig">
          <div className="css-1u0m1fa">
            <div className="css-fhl5lc">
              <span className="css-1cdfkn6">Quản lý xác thực thực sự</span>
            </div>
          </div>
          <div className="css-1bbywci">
            <div className="css-1pl31wt">
              <div className="css-k2y2sp">
                <div className="css-1868gi1">Thông tin chứng nhận</div>
              </div>
            </div>
            <div className="css-z32tht">
              {user?.is_verify === 1 && (
                <div className="css-joa6mv !bg-[#13834f29]">
                  <span className="f12 text-[#13834f]">
                    <FontAwesomeIcon icon={faCheckCircle} />
                    Tài khoản đã xác minh thành công
                  </span>
                </div>
              )}
              {user?.is_verify === 3 && (
                <div className="css-joa6mv !bg-[#ffd45f30]">
                  <span className="f12 text-[#ffc21b]">
                    <FontAwesomeIcon icon={faInfoCircle} />
                    Tài khoản đang chờ xác minh
                  </span>
                </div>
              )}
              {!user?.is_verify && <KYCForm />}
            </div>
          </div>
        </div>
      </main>
    </main>
  );
});

export default DesktopKYC;
